import { useLocation } from "react-router-dom";
import StakeAIChat from "./stake-ai-chat";

import { useRedirectContext } from "../../Contexts/RedirectContext";
import { LocalStorage } from "../../Utils/helpers";
import { STEP_IDS } from "./flow/schema";

export default function Welcome() {
  const { markVisitedWelcomePage } = useRedirectContext();
  const location = useLocation();

  // Set deep link values synchronously before ChatEngine initializes
  if (location.pathname === "/welcome/find-a-home") {
    // Pre-populate answers to simulate clicking "I'm looking to rent an apartment"
    const existingAnswers = LocalStorage.read("welcome_flow_answers") || {};
    const deepLinkAnswers = {
      ...existingAnswers,
      persona: "renter",
      renterReasons: ["find-home"],
      useCase: "renter_find_home",
    };
    LocalStorage.write("welcome_flow_answers", deepLinkAnswers);
    
    // Skip the greeting step
    LocalStorage.write("welcome_flow_greet_done", true);
    
    // Set custom initial step to start directly at find home consent
    LocalStorage.write("welcome_flow_custom_initial_step", STEP_IDS.RENTER_FIND_HOME_CONSENT);
  }

  return <StakeAIChat onComplete={markVisitedWelcomePage} />;
}
